
import Dialog from 'primevue/dialog'
import Card from 'primevue/card'
import Button from 'primevue/button'
import moment from 'moment'

import {
  defineComponent,
  computed,
  reactive,
  ref,
  toRefs,
  onMounted,
  getCurrentInstance
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { IDeposit } from '@/utils/interfaces/iDeposit'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'

export default defineComponent({
  name: 'ModalDefault',
  components: {
    Dialog,
    Card,
    Button
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    id: {
      type: String,
      default: ''
    }
  },
  emits: ['hideApproveDialog', 'submit', 'currencyNumberFormat'],
  setup(props, { emit }: any) {
    const { show, id } = toRefs(props)
    const app = getCurrentInstance()
    const {
      $toast
    } = app!.appContext.config.globalProperties
    const store = useStore()
    const router = useRouter()
    const dataSource = ref<IDeposit>()
    const endpoint = '/transaction/v1/TransactionPp/Deposit'
    const endpointTransV2 = 'transaction/v2/TransactionPps'
    const endpointLatestExpensesRevision = 'transaction/v1/RitExpenseRevision/Latest-Revision'
    const isLoading = ref(true)
    const expensetemp = ref(0)

    const showModal = show.value

    const getDetail = async () => {
      const {
        result,
        error
      } = await apiUseCase.get(`${endpoint}/${id.value}`)
      if (!error) {
        const resultMap: IDeposit = result
        dataSource.value = resultMap
        // eslint-disable-next-line array-callback-return
        dataSource.value.Rits.map((x) => {
          expensetemp.value += x.RitExpenseTotalAmount
        })
        isLoading.value = false
      }
      store.dispatch('hideLoading')
    }

    const printClosedStat = async (data: any) => {
      store.dispatch('showLoading')
      const payload = {}
      await apiUseCase.getBlob(`${endpointTransV2}/${data.Id}/Export`).then((response) => {
        const { error, result } = response
        if (!error) {
          $toast.add({
            severity: 'success',
            detail: 'Data berhasil didownload',
            group: 'bc',
            closable: false,
            life: 3000
          })
          const blob = result
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = `laporan Setoran Harian ${data.TrxId} (${moment().format('DD MMMM YYYY')}).pdf`
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        } else {
          $toast.add({
            severity: 'error',
            detail: 'Data gagal didownload',
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
      })
      store.dispatch('hideLoading')
    }

    const closeDialog = () => {
      emit('hideApproveDialog')
    }

    const submit = () => {
      console.log('id', id.value)
      emit('submit', id.value)
    }

    const goDetail = (item: any) => {
      const token = localStorage.getItem('ut')
      const routeData = router.resolve({ name: 'reports-detail', params: { typeReport: `${item.Report.Query}?TransactionPpId=${item.Id}&Token=${token}` } })
      window.open(routeData.href, '_blank')
    }

    onMounted(() => {
      console.log('show', show.value)
      getDetail()
    })

    return {
      dataSource,
      showModal,
      closeDialog,
      submit,
      isLoading,
      moment,
      currencyNumberFormat,
      expensetemp,
      // goDetail,
      printClosedStat
    }
  }
})
